export const ENDPOINT_CONTEXT = 'glob:/api/lending/edge/context*';
export const ENDPOINT_PROFILE = '/api/lending/edge/profile/';
export const ENDPOINT_POST_CUSTOMER_STATE = 'glob:/api/lending/edge/state/';
export const ENDPOINT_CUSTOMER_STATE = 'glob:/api/lending/edge/state/*';
export const ENDPOINT_COMPANY_SEARCH = 'glob:/api/lending/edge/company_search/';
export const ENDPOINT_APPLICATION = 'glob:/api/lending/edge/application/*/';
export const ENDPOINT_FORMAL_INDICATIVE_OFFERS =
    'glob:/api/lending/edge/formal_indicative_offers/*/';
export const ENDPOINT_FORMAL_OFFERS = `glob:/api/lending/edge/formal_offers/*/`;
export const ENDPOINT_DECLINE_APPLICATION = `glob:/api/lending/edge/application/*/decline/`;
export const ENDPOINT_SELECT_OFFER = `glob:/api/lending/edge/offers/*/select/`;
export const ENDPOINT_OFFERS = `glob:/api/lending/edge/applications/*/offers/`;
export const ENDPOINT_EMAIL_AVAILABILITY =
    'glob:/api/lending/edge/email_availability/';
export const ENDPOINT_ACCESS_LOG = '/api/access_log/';
export const ENDPOINT_SPLIT_TEST = 'glob:/api/lending/edge/split_test';
